import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/whisper.vue
var o = {
	name: "DtIconWhisper",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--whisper"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Whisper",
		viewBox: "0 0 11 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6.75 1.5a2.75 2.75 0 0 0-2.676 2.115.5.5 0 0 1-.973-.23 3.75 3.75 0 0 1 7.399.865c0 .841-.213 1.495-.544 2.03-.325.523-.752.91-1.136 1.23l-.249.204c-.29.237-.53.433-.723.658-.223.26-.348.524-.348.878a2.25 2.25 0 0 1-4.329.861.5.5 0 1 1 .924-.383A1.25 1.25 0 0 0 6.5 9.25c0-.646.25-1.132.59-1.529.256-.299.585-.567.884-.811.07-.058.14-.114.206-.17.366-.304.69-.606.926-.988.231-.372.394-.843.394-1.502A2.75 2.75 0 0 0 6.75 1.5ZM5.513 3.013A1.75 1.75 0 0 1 8.5 4.25a.5.5 0 0 1-1 0 .75.75 0 0 0-1.5 0v.086a1.5 1.5 0 0 1 .56.353.5.5 0 0 1-.706.707.5.5 0 0 0-.354-.146.5.5 0 0 1-.5-.5v-.5c0-.464.184-.91.513-1.237ZM1.955 4.338a.5.5 0 0 1 .707 0L4.47 6.146a.5.5 0 0 1 0 .708L2.662 8.662a.5.5 0 1 1-.707-.707L2.909 7H.5a.5.5 0 0 1 0-1h2.41l-.954-.955a.5.5 0 0 1 0-.707Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=whisper.js.map